import { post } from "./api.js";
import { labels } from "./config.js";
import { setBusy, showFieldError, showNotice } from "./components.js";
import { clearVerificationState, handleLoginPayload, verificationState } from "./session.js";

export function initVerification() {
	const form = document.querySelector("[data-auth-verification-form]");
	if (!form) return;
	const otp = form.elements.otp;
	const prompt = document.querySelector("[data-auth-verification-prompt]");
	const state = verificationState();
	const message = String(state.verification?.prompt || "").trim();
	if (message && prompt) {
		prompt.textContent = message;
		prompt.hidden = false;
	}
	if (!state.tmpId) {
		showNotice(form, labels.verificationExpired);
		form.querySelector("[data-auth-submit]").disabled = true;
		return;
	}

	form.addEventListener("submit", async (event) => {
		event.preventDefault();
		showNotice(form, "");
		if (!otp.value.trim()) {
			showFieldError(otp, labels.verificationRequired);
			return;
		}
		setBusy(form, true, labels.verifying);
		try {
			const payload = await post("/api/method/login", {
				otp: otp.value.trim(),
				tmp_id: state.tmpId,
			});
			if (!handleLoginPayload(payload)) showNotice(form, labels.incorrectVerification);
		} catch (error) {
			if (error.status === 417) {
				clearVerificationState();
				showNotice(form, labels.verificationExpired);
			} else {
				showNotice(form, labels.incorrectVerification);
			}
		} finally {
			setBusy(form, false, labels.verifying);
		}
	});
}
